import React from "react";
import { DataGrid } from '@mui/x-data-grid';

const columns = [
    { field: 'member_id', headerName: 'ID', width: 70, hide: true },
    { field: 'name', headerName: 'Nume', width: 130 },
    { field: 'firstname', headerName: 'Prenume', width: 90 },
    { field: 'sex', headerName: 'Sex', width: 90 },
    { field: 'race', headerName: 'Cursa', sortable: false, width: 160, },
    { field: 'team', headerName: 'Echipa', width: 160, },
    { field: 'user_id', headerName: 'User', sortable: false, width: 90, hide: true },
];

const MembersDataTable = (props) => {
    const { rows } = props;
    const loading = props.loading;
    const selectRow = props.selectRow;

    return (
        <div style={{ height: 400, width: '100%', color: 'white' }}>
            <DataGrid
                className='data-table-container'
                rows={rows}
                columns={columns}
                pageSize={50}
                rowsPerPageOptions={[50]}
                checkboxSelection
                loading={loading}
                onSelectionModelChange={selectRow}
            />
        </div>
    );
}

export default MembersDataTable;